import * as React from 'react'

import { Fields } from 'embed/constants/fields'
import { Product } from 'even-ts-static'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationField } from 'embed/components/ApplicationField/container'

import Wrapper from '../Wrapper'

export interface Props {
  directReferral: boolean
  dispatchBackToStepOne: () => void
  onBack: () => void
  onContinue: () => void
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
}

export const StepbystepApplicationStepMonthlyPayment: React.FC<Props> = (props) => (
  <Wrapper {...props}>
    <StepTitle>What’s the monthly payment for the auto loan you are refinancing?</StepTitle>
    <ApplicationField product={Product.Loan} field={Fields.MonthlyPayment} />
  </Wrapper>
)
